import { render } from "./PaymentBlock.vue?vue&type=template&id=64ef4af5&scoped=true"
import script from "./PaymentBlock.vue?vue&type=script&lang=js"
export * from "./PaymentBlock.vue?vue&type=script&lang=js"

import "./PaymentBlock.vue?vue&type=style&index=0&id=64ef4af5&scoped=true&lang=css"
import "./PaymentBlock.vue?vue&type=style&index=1&id=64ef4af5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ef4af5"]])

export default __exports__